// Source: https://play.tailwindcss.com/faQEiRVkjv
module.exports = () => ({
  "label .radio": {
    "@apply ds-align-middle ds-mr-sm ds-mt-2xs ds-top-[-4px]": true,
  },
  ".radio": {
    "@apply ds-appearance-none ds-h-xl ds-w-xl ds-border ds-rounded-full ds-border-tertiary-lightgrey ds-relative ds-opacity-100": true,
  },
  ".radio::before": {
    content: '""',
    left: "calc(50% - 6px)",
    top: "calc(50% - 6px)",
    "@apply ds-bg-tertiary-lightergrey ds-h-sm ds-w-sm ds-rounded-full ds-absolute ds-scale-0 ds-transition-transform ds-ease-in-out ds-duration-150": true,
  },
  ".radio.indeterminate:not(:checked)::before": {
    left: "calc(50% - 8px)",
    top: "calc(50% - 1px)",
    width: "16px",
    height: "2px",
    "@apply ds-scale-100 ds-bg-tertiary-mediumgrey ds-rounded-none": true,
  },
  ".radio:not(:checked)::before": { "@apply ds-scale-0": true },
  ".radio:not(:checked, :disabled):hover,\n.radio:not(:checked, :disabled).hover": {
    "@apply ds-ring-primary-black ds-outline-none ds-ring-4 ds-ring-opacity-5": true,
  },
  ".radio:not(:checked, :disabled):hover::before,\n.radio:not(:checked, :disabled).hover::before,\n.radio:not(:checked, :disabled):focus::before,\n.radio:not(:checked, :disabled).focus::before,\n.radio:not(:checked, :disabled):active::before,\n.radio:not(:checked, :disabled).active::before":
    {
      "@apply ds-bg-tertiary-lightergrey ds-scale-100": true,
    },
  ".radio:not(:checked, :disabled):focus,\n.radio:not(:checked, :disabled).focus": {
    "@apply ds-ring-primary-black ds-outline-none ds-ring-4 ds-ring-opacity-10": true,
  },
  ".radio:not(:checked, :disabled):active,\n.radio:not(:checked, :disabled).active": {
    "@apply ds-ring-primary-black ds-outline-none ds-ring-4 ds-ring-opacity-[0.15]": true,
  },
  ".radio:not(:checked):disabled": {
    "@apply ds-border-tertiary-lightgrey ds-bg-primary-black-10 ds-cursor-not-allowed": true,
  },
  ".radio:checked": { "@apply ds-border-tertiary-mediumgrey": true },
  ".radio:checked::before": {
    "@apply ds-bg-tertiary-darkgrey ds-scale-100": true,
  },
  ".radio:checked:not(:disabled):hover,\n.radio:checked:not(:disabled).hover": {
    "@apply ds-border-primary-blue-70 ds-ring-primary-blue ds-outline-none ds-ring-4 ds-ring-opacity-10": true,
  },
  ".radio:checked:not(:disabled):focus,\n.radio:checked:not(:disabled).focus": {
    "@apply ds-border-primary-blue-70 ds-ring-primary-blue ds-outline-none ds-ring-4 ds-ring-opacity-20": true,
  },
  ".radio:checked:not(:disabled):active,\n.radio:checked:not(:disabled).active": {
    "@apply ds-border-primary-blue-70 ds-ring-primary-blue ds-outline-none ds-ring-4 ds-ring-opacity-30": true,
  },
  ".radio:checked:disabled": {
    "@apply ds-border-tertiary-lightgrey ds-bg-primary-black-10 ds-cursor-not-allowed": true,
  },
  ".radio:checked:disabled::before": {
    "@apply ds-text-tertiary-mediumgrey": true,
  },
  ".radio.invalid": { "@apply ds-border-secondary-red-70": true },
  ".radio.invalid:not(:disabled):hover,\n.radio.invalid:not(:disabled).hover": {
    "@apply ds-ring-secondary-red ds-outline-none ds-ring-4 ds-ring-opacity-10": true,
  },
  ".radio.invalid:not(:disabled):focus,\n.radio.invalid:not(:disabled).focus": {
    "@apply ds-ring-secondary-red ds-outline-none ds-ring-4 ds-ring-opacity-20": true,
  },
  ".radio.invalid:not(:disabled):active,\n.radio.invalid:not(:disabled).active": {
    "@apply ds-ring-secondary-red ds-outline-none ds-ring-4 ds-ring-opacity-30": true,
  },
  ".radio.invalid:disabled": {
    "@apply ds-border-tertiary-lightgrey ds-cursor-not-allowed": true,
  },
  ".radio.invalid:disabled::before": {
    "@apply ds-border-secondary-red-30": true,
  },
});
